<template>
  <dialog id="cmd_result_modal" class="modal">
    <div class="modal-box container max-h-screen">
      <h3
        class="mb-4 flex items-center justify-between gap-10 text-lg font-bold"
      >
        <span v-if="!loading">{{ args }}</span>
        <div v-if="loading" class="skeleton h-7 w-full"></div>
        <div class="tooltip tooltip-left" data-tip="Sao chép kết quả">
          <button class="btn" @click="result && copyTextToClipboard(result)">
            <i class="fa-solid fa-copy"></i>
          </button>
        </div>
      </h3>
      <div
        v-if="!loading"
        class="mockup-code max-h-[calc(100vh-200px)] overflow-auto px-4"
      >
        <pre><code>{{ result }}</code></pre>
      </div>
      <Loading v-if="loading" />
      <div class="modal-action">
        <form method="dialog">
          <button class="btn">Tắt</button>
        </form>
      </div>
    </div>
  </dialog>
</template>

<script setup lang="ts">
import Loading from "@/components/LoadingTemplate.vue";
import { copyTextToClipboard } from "@/types/util";

defineProps<{
  loading?: boolean;
  args?: string;
  result?: string;
}>();
</script>
